module.exports = __webpack_public_path__ + "static/media/logo_no-text.0edc9134.svg";